
<v-col cols="3 position-relative">
  <div class="custom-control custom-checkbox">
    <input type="checkbox" :checked="isSelected" class="custom-control-input mr-1" :id="'checkDoc_' + file.id" @change="toggleSelection" />
    <label class="custom-control-label" :for="'checkDoc_' + file.id"></label>
  </div>
  <v-card class="library-card" @click="openPreview">
    <div class="secondary card-preview d-flex align-center justify-center">
      <div class="card-preview-content d-flex align-center justify-center">
        <h1 class="grey--text mb-0">.{{file.extension}}</h1>
      </div>
    </div>
    <v-card-text class="card-details d-flex flex-column justify-center">
      <h5 class="mb-0" style="flex: 1 1 auto;">
        <b>{{truncateName(file.name)}}</b>
      </h5>
      <span v-if="hasCases" style="flex: 1 1 auto;">{{ displayCaseNames }}</span>
      <span v-else style="flex: 1 1 auto;"><i>No assigned case</i></span>
      <span style="flex: 1 1 auto;">{{prettyDate(file.created_at)}}</span>
    </v-card-text>
  </v-card>
</v-col>
